import { z } from 'zod';

export const organizationFormSchema = z.object({
  org_name: z.string().min(1, 'Organization name is required'),
  org_phone: z.string().min(1, 'Organization phone is required'),
  email: z.string().min(1, 'Email is required').email('Invalid email format'),
  sync_link: z.string().optional(),
  client_owner: z
    .string()
    .max(128, 'Client owner must be 128 characters or fewer')
    .optional()
    .or(z.literal('')),
  notification_email: z
    .string()
    .min(1, 'Notification email is required')
    .email('Invalid email format'),
  client_address: z.object({
    street: z.string().min(1, 'Street address is required'),
    city: z.string().min(1, 'City is required'),
    state: z
      .string()
      .min(1, 'State is required')
      .length(2, 'State must be exactly 2 characters')
      .transform((val) => val.trim().toUpperCase()),
    zip: z.string().min(1, 'Zip code is required'),
  }),
  timezone: z.string().min(1, 'Timezone is required'),
});

export type OrganizationFormData = z.infer<typeof organizationFormSchema>;
